/* DT Header: mega menu, hamburger panels, mobile menu, scroll lock, focus trap, cart opener fallback. */
(function () {
  'use strict';
  var root = document.querySelector('[data-dt-header]');
  if (!root || root.__dtInit) return;
  root.__dtInit = true;

  var html = document.documentElement;
  var bar = root.querySelector('.dt-hdr__bar');
  var burger = root.querySelector('[data-dt-burger]');
  var desktopMQ = window.matchMedia('(min-width: 1200px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var OPEN_DELAY = 120, CLOSE_DELAY = 250;
  var openTimer = null, closeTimer = null;
  var current = null;   // { id, el, trigger, mode }
  var lastFocus = null;

  function panelById(id) {
    if (id === 'menu') return root.querySelector('.dt-menu');
    if (id === 'mobile') return root.querySelector('.dt-mobile');
    return root.querySelector('.dt-mega[data-dt-panel="' + id + '"]');
  }
  function triggerFor(id) {
    if (id === 'menu' || id === 'mobile') return burger;
    return root.querySelector('[data-dt-mega="' + id + '"]');
  }

  function setTop() {
    var r = bar.getBoundingClientRect();
    root.style.setProperty('--dt-top', Math.round(r.bottom) + 'px');
  }

  function lock() {
    var sbw = window.innerWidth - html.clientWidth;
    root.style.setProperty('--dt-sbw', Math.max(sbw, 0) + 'px');
    html.classList.add('dt-hdr-lock');
  }
  function unlock() {
    html.classList.remove('dt-hdr-lock');
    root.style.setProperty('--dt-sbw', '0px');
  }

  function focusables(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])'),
      function (n) { return n.offsetParent !== null || n === document.activeElement; }
    );
  }

  function setBurger(open) {
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function open(id, mode) {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (current && current.id === id) { if (mode !== 'hover') current.mode = mode; return; }
    if (current) close(true);
    var el = panelById(id);
    if (!el) return;
    var trigger = triggerFor(id);
    showHeader();
    setTop();
    lock();
    el.classList.add('is-open');
    if (id === 'menu' || id === 'mobile') setBurger(true);
    else if (trigger) trigger.setAttribute('aria-expanded', 'true');
    current = { id: id, el: el, trigger: trigger, mode: mode };
    lastFocus = document.activeElement;
    if (mode === 'key') {
      var f = focusables(el)[0];
      if (f) setTimeout(function () { f.focus(); }, reduce.matches ? 0 : 60);
    }
  }

  function close(skipFocus) {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (!current) return;
    var c = current;
    current = null;
    c.el.classList.remove('is-open');
    if (c.id === 'menu' || c.id === 'mobile') {
      setBurger(false);
      root.querySelectorAll('.dt-sub.is-open').forEach(closeSub);
    } else if (c.trigger) {
      c.trigger.setAttribute('aria-expanded', 'false');
    }
    unlock();
    if (!skipFocus && c.mode !== 'hover' && c.trigger) c.trigger.focus();
  }

  function scheduleOpen(id) {
    clearTimeout(closeTimer);
    clearTimeout(openTimer);
    openTimer = setTimeout(function () { open(id, 'hover'); }, current ? 0 : OPEN_DELAY);
  }
  function scheduleClose() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (!current || current.mode !== 'hover') return;
    closeTimer = setTimeout(function () { if (current && current.mode === 'hover') close(true); }, CLOSE_DELAY);
  }

  /* ---------- desktop mega: hover / focus / click ---------- */
  root.querySelectorAll('[data-dt-mega]').forEach(function (btn) {
    var id = btn.getAttribute('data-dt-mega');
    btn.addEventListener('mouseenter', function () { if (desktopMQ.matches) scheduleOpen(id); });
    btn.addEventListener('mouseleave', function () { if (desktopMQ.matches) scheduleClose(); });
    btn.addEventListener('focus', function () {
      if (desktopMQ.matches && btn.matches(':focus-visible')) { clearTimeout(closeTimer); open(id, 'key'); btn.focus(); }
    });
    btn.addEventListener('click', function (e) {
      if (!desktopMQ.matches) return;
      var keyboard = e.detail === 0;
      if (current && current.id === id && current.mode !== 'hover' && !keyboard) { close(true); return; }
      if (current && current.id === id && current.mode === 'hover') { current.mode = 'click'; return; }
      open(id, keyboard ? 'key' : 'click');
    });
  });
  root.querySelectorAll('.dt-mega, .dt-menu').forEach(function (p) {
    p.addEventListener('mouseenter', function () { clearTimeout(closeTimer); clearTimeout(openTimer); });
    p.addEventListener('mouseleave', function () { if (desktopMQ.matches) scheduleClose(); });
  });

  /* ---------- hamburger (desktop menu panel / mobile panel) ---------- */
  if (burger) {
    burger.addEventListener('click', function (e) {
      var id = desktopMQ.matches ? 'menu' : 'mobile';
      if (current && (current.id === 'menu' || current.id === 'mobile')) { close(); return; }
      open(id, e.detail === 0 ? 'key' : 'click');
    });
  }
  root.querySelectorAll('[data-dt-close]').forEach(function (b) {
    b.addEventListener('click', function () { close(); });
  });

  /* ---------- mobile sublevel ---------- */
  function closeSub(sub) {
    sub.classList.remove('is-open');
    sub.setAttribute('aria-hidden', 'true');
    var t = root.querySelector('[data-dt-sub="' + sub.getAttribute('data-dt-subpanel') + '"]');
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  root.querySelectorAll('[data-dt-sub]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = root.querySelector('[data-dt-subpanel="' + btn.getAttribute('data-dt-sub') + '"]');
      if (!sub) return;
      sub.classList.add('is-open');
      sub.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
      var back = sub.querySelector('[data-dt-back]');
      if (back) setTimeout(function () { back.focus(); }, 80);
    });
  });
  root.querySelectorAll('[data-dt-back]').forEach(function (b) {
    b.addEventListener('click', function () {
      var sub = b.closest('.dt-sub');
      closeSub(sub);
      var t = root.querySelector('[data-dt-sub="' + sub.getAttribute('data-dt-subpanel') + '"]');
      if (t) t.focus();
    });
  });

  /* ---------- keyboard: Esc + focus trap ---------- */
  document.addEventListener('keydown', function (e) {
    if (!current) return;
    if (e.key === 'Escape') {
      var openSub = root.querySelector('.dt-sub.is-open');
      if (openSub) { openSub.querySelector('[data-dt-back]').click(); return; }
      close();
      return;
    }
    if (e.key !== 'Tab' || current.mode === 'hover') return;
    var scope = root.querySelector('.dt-sub.is-open') || current.el;
    var list = focusables(scope);
    if (current.trigger && scope === current.el && current.id !== 'mobile') list = [current.trigger].concat(list);
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1], a = document.activeElement;
    if (!scope.contains(a) && a !== current.trigger) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  });

  /* click outside closes desktop panels */
  document.addEventListener('click', function (e) {
    if (!current || !desktopMQ.matches) return;
    if (current.el.contains(e.target) || root.contains(e.target) && e.target.closest('[data-dt-mega],[data-dt-burger]')) return;
    close(true);
  });

  /* switching breakpoint, resize or scroll: keep layout valid */
  function onMQ() { if (current) close(true); }
  if (desktopMQ.addEventListener) desktopMQ.addEventListener('change', onMQ); else desktopMQ.addListener(onMQ);
  window.addEventListener('resize', function () { if (current) setTop(); });


  /* ---------- smart sticky ----------
     At the top: solid. Scrolling down past the header: it hides. Scrolling up: it returns translucent.
     Only .dt-hdr__bar is transformed, so the fixed panels keep working. Stays visible while a panel or the cart drawer is open. */
  var sticky = root.getAttribute('data-sticky') === 'true';
  var hideOnScroll = root.getAttribute('data-hide-on-scroll') === 'true';
  var wrapper = root.closest('.shopify-section') || root.parentElement;
  var hidden = false, translucent = false, lastY = window.scrollY, ticking = false;

  function naturalTop() {
    var top = 0, el = wrapper && wrapper.previousElementSibling;
    while (el) { top += el.offsetHeight || 0; el = el.previousElementSibling; }
    return top;
  }
  function apply() {
    root.classList.toggle('is-hidden', hidden);
    root.classList.toggle('is-translucent', translucent);
    if (wrapper) wrapper.style.pointerEvents = hidden ? 'none' : '';
  }
  function showHeader() {
    if (!sticky) return;
    if (hidden) { hidden = false; apply(); }
  }
  function drawerOpen() {
    var d = document.querySelector('cart-drawer');
    return !!(d && d.classList.contains('active'));
  }
  function onScroll() {
    ticking = false;
    var y = window.scrollY, dy = y - lastY;
    var base = naturalTop();
    var barH = bar.offsetHeight;
    if (y <= base + 4) {
      translucent = false; hidden = false; lastY = y; apply(); return;
    }
    translucent = true;
    if (current || drawerOpen() || !hideOnScroll) { hidden = false; lastY = y; apply(); return; }
    if (Math.abs(dy) >= 6) {
      if (dy > 0 && y > base + barH) hidden = true;
      else if (dy < 0) hidden = false;
      lastY = y;
    }
    apply();
  }
  if (sticky) {
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
    }, { passive: true });
    onScroll();
  }

  /* ---------- cart: open Shrine's drawer ----------
     Shrine binds the click on #cart-icon-bubble (same id/classes as its own header).
     If its handler did not take the click (defaultPrevented false), open the drawer ourselves. */
  var cartLink = document.getElementById('cart-icon-bubble');
  if (cartLink && cartLink.closest('[data-dt-header]') === root) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('#cart-icon-bubble');
      if (!a || e.defaultPrevented) return;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        if (current) close(true);
        drawer.open(a);
      }
    });
  }
})();
